import { render, staticRenderFns } from "./SortMenu.vue?vue&type=template&id=7ecdb2fd&"
import script from "./SortMenu.vue?vue&type=script&lang=js&"
export * from "./SortMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports